module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_06-7937c46f833a8f3413cf315cb04f7237.jpg";